import usePermissions from 'api/usePermissions';
import { User } from 'common/contracts';
import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';
import { permissionsUtil } from 'utils/permissionsUtil';
import { getSelectProjectOptions } from 'utils/projectsUtil';

export function useAllowedPublisherForProjects() {
  const projectsDetails =
    localStorageUtil.getAny<User>(ELocalStorageKeys.USER_DETAILS)?.projects ||
    [];

  const { getPermissions } = usePermissions();
  const permissions = getPermissions();
  const allowedPublishers =
    permissionsUtil.getAccessPublisherOrders(permissions);

  const allowedProjects = getSelectProjectOptions(
    projectsDetails,
    allowedPublishers
  ).map((project) => project.value);

  return { allowedProjects };
}
